import React from 'react';
import moment from 'moment';
import { CSVLink } from "react-csv";
import { useIntl } from 'react-intl';
import {toNativeDate} from "../../Function/globalFunction";
import { CashOutApprovalHistoryCollection } from '../../Function/CashOutApproval';
import {makeStyles, Typography} from '@material-ui/core';
import { getCashOutApprovalHistory } from '../api/ApprovalAPI';

const useStyles = makeStyles((theme) => ({
    csvLink: {
        color: 'white',
        '&:hover': {
            color: 'white',
        },
        display: 'contents'
    },
    button: {
        height: '2.8em',
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        }
    },
}));

export default function DetailsReport({ fromDate, toDate, setIsActive }) {
    const classes = useStyles();
    const intl = useIntl();
    const [filename, setFilename] = React.useState('');
    const [reportData, setReportData] = React.useState([]);
    const buttonText = intl.formatMessage({ id: 'cash_out.export_details' });
    const csvLink = React.useRef();

    const getData = async () => {
        setIsActive(true);
        const response = await getCashOutApprovalHistory(fromDate, toDate);
        if (response.status === 200) {
            setReportData(CashOutApprovalHistoryCollection(response.data, intl));
            setIsActive(false);
            csvLink.current.link.click();
        } else {
            setReportData([]);
        }
    }

    React.useEffect(() => {
        let fromDisplayDate = moment(toNativeDate(fromDate)).format(window.global.momentFormat);
        let toDisplayDate = moment(toNativeDate(toDate)).format(window.global.momentFormat);
        setFilename('Cash_Out_Details_Report_' + fromDisplayDate + '_To_' + toDisplayDate + '.csv');
    }, [fromDate, toDate]);

    const headers = [
        { label: intl.formatMessage({ id: 'leave_approval.staff_number' }), key: "staffNo" },
        { label: intl.formatMessage({ id: 'leave_approval.employee' }), key: "employee" },
        { label: intl.formatMessage({ id: 'leave_approval.position' }), key: "position" },
        { label: intl.formatMessage({ id: 'leave_approval.location' }), key: "location" },
        { label: intl.formatMessage({ id: 'leave_approval.department' }), key: "department" },
        { label: intl.formatMessage({ id: 'hr_admin.staff_duty' }), key: "staffDuty" },
        { label: intl.formatMessage({ id: 'hr_admin.staff_status' }), key: "staffStatus" },
        { label: intl.formatMessage({ id: 'common.from' }), key: "from" },
        { label: intl.formatMessage({ id: 'common.to' }), key: "to" },
        { label: intl.formatMessage({ id: 'comp_leave.justification' }), key: "justification" },
        { label: intl.formatMessage({ id: 'cash_out.cashed_out_hours' }), key: "remaining" },
        { label: intl.formatMessage({ id: 'table.date_approved' }), key: "dateApproved" },
    ];

    return (
        <div>
            <Typography onClick={getData} style={{ color: '#000' }}>
                {buttonText}
            </Typography>
            <CSVLink
                filename={filename}
                data={reportData}
                headers={headers}
                className={classes.csvLink}
                ref={csvLink}
            />
        </div>
    );
}